export default {"and_chr":126,"android":126,"chrome":79,"edge":117,"firefox":115,"ios_saf":16.3,"opera":101,"safari":16.3};